import { render, staticRenderFns } from "./projectOnlineTop10.vue?vue&type=template&id=a6c96692&scoped=true&"
import script from "./projectOnlineTop10.vue?vue&type=script&lang=js&"
export * from "./projectOnlineTop10.vue?vue&type=script&lang=js&"
import style0 from "./projectOnlineTop10.vue?vue&type=style&index=0&id=a6c96692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c96692",
  null
  
)

export default component.exports